import React, { useState, useEffect, useRef } from "react";

import { useParams } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";

import { TwitterTimelineEmbed, TwitterFollowButton } from "react-twitter-embed";
import {
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaTwitch,
  FaGlobe,
} from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom";

import { usePlayers } from "../api/DataContext";
export default function Member() {
  const location = useLocation();
  const { players, isLoading } = usePlayers();
  const history = useHistory();
  const org = window.parent.location.hostname;
  const [banner, setbanner] = useState("#0C0B11");
  const [stats, setStats] = useState(null);
  const [yt, setYt] = useState(null);

  const wrapperRef = useRef(null);
  const [recentVideos, setRecentVideos] = useState([]);

  const [recentVideosIds, setRecentVideosIds] = useState([]);
  const { userId } = useParams();

  const ytRecent = (channel) => {
    //     fetch(`https://youtube.googleapis.com/youtube/v3/search?part=snippet&channelId=${channel}&maxResults=8&order=date&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`, {
    // "method": "GET"
    // }
    fetch(
      `https://youtube-v31.p.rapidapi.com/search?channelId=${channel}&part=snippet%2Cid&order=date&maxResults=8`,
      {
        method: "GET",
        headers: {
          "x-rapidapi-host": "youtube-v31.p.rapidapi.com",
          "x-rapidapi-key":
            "84af782d06mshf9e7aa82a3b568ep1032f3jsn26047af9fcf6",
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setRecentVideosIds(data.items.map((x) => x.id.videoId));
      })

      .catch((err) => {});
  };
  useEffect(() => {
    if (location.hash === "") window.scrollTo(0, 0);
  }, [location]);
  useEffect(() => {
    if (!isLoading) {
      const isPlayer = players.find(({ ign }) => ign === userId);
      if (!isPlayer) history.push("/team");
      else {
        setStats(isPlayer);
        setbanner(isPlayer.banner);
        if (isPlayer.yt) {
          setYt(isPlayer.yt);
        }
        try {
          wrapperRef.current.classList.add("fading-out");
        } catch (e) {}
        setTimeout(() => {
          try {
            wrapperRef.current.classList.add("d-none");
          } catch (e) {}
        }, 300);
      }
    }
  }, [userId, isLoading]);

  useEffect(() => {
    if (yt !== null) {
      ytRecent(yt);
    }
  }, [yt]);

  const ytVideo = async (video) => {
    const response = await fetch(
      `https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2Cstatistics&id=${video}&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`,
      {
        method: "GET",
      }
    );
    const data = await response.json();
    return data.items[0];
  };
  useEffect(() => {
    const mapLoop = async (_) => {
      if (recentVideosIds !== null) {
        // recentVideosIds.map((x)=>{
        //     ytVideo(x).then(details=>{
        //       setRecentVideos(recentVideos => [...recentVideos, details])
        //     })

        // })
        const promises = recentVideosIds.map(async (fruit) => {
          const numFruit = await ytVideo(fruit);
          return numFruit;
        });

        const numFruits = await Promise.all(promises);
        setRecentVideos(numFruits);
      }
    };
    mapLoop();
  }, [recentVideosIds]);

  const viewCounts = (labelValue) => {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
      : Math.abs(Number(labelValue));
  };
  return (
    <>
      {
        <>
          <div className="teamWrapper" ref={wrapperRef}></div>
          <div
            style={{ backgroundImage: `url(${banner})` }}
            className="player-banner"
          ></div>
          <div
            className="mx-auto px-0 px-md-5 d-flex flex-column justify-content-between  text-white   "
            style={{
              width: "100%",
              minHeight: "75vh",
              background: "#0C0B11",
            }}
          >
            <Container fluid>
              <Row className="px-2  d-flex  justify-content-start align-items-center member-top">
                <div className="w-25 d-none d-md-block">
                  {stats && stats.photo && (
                    <img
                      src={stats.photo}
                      className="mx-auto member-photo dropshadow "
                      alt="player"
                    />
                  )}
                </div>
                <div className="w-100 d-block d-md-none text-center">
                  {stats && stats.photo && (
                    <img
                      src={stats.photo}
                      className="mx-auto member-photo dropshadow "
                      alt="player"
                    />
                  )}
                </div>
                <div className="py-3 d-none d-md-flex  flex-column justify-content-center align-items-start w-75">
                  {stats && stats.ign && <h3 className="fs-4 ">{stats.ign}</h3>}
                  {stats && stats.name && (
                    <h3 className="fs-5 text-brand fw-light">{stats.name}</h3>
                  )}
                  <div className="py-2 d-flex justify-content-around align-items-center mx-auto mx-md-0 ">
                    {stats &&
                      stats.tags &&
                      stats.tags.map((x, index) => {
                        return (
                          <span
                            key={index}
                            className="bg-brandtext text-dark px-2 py-1  fw-bold shadow fs-6 rounded-3 me-2 my-1"
                          >
                            {x}
                          </span>
                        );
                      })}
                  </div>
                  <div className="d-flex justify-content-around align-items-center mx-auto mx-md-0">
                    {stats && stats.socials.twitter && (
                      <a
                        className="d-flex nav-link my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.twitter}
                      >
                        <FaTwitter size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.instagram && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.instagram}
                      >
                        <FaInstagram size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.youtube && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.youtube}
                      >
                        <FaYoutube size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.twitch && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.twitch}
                      >
                        <FaTwitch size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.website && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.website}
                      >
                        <FaGlobe size={16} className="" />
                      </a>
                    )}{" "}
                  </div>
                </div>
                <div className="d-flex py-3 d-md-none w-100  flex-column justify-content-center align-items-center ">
                  {stats && stats.ign && <h3 className="fs-4">{stats.ign}</h3>}
                  {stats && stats.name && (
                    <h3 className="fs-5 text-brand fw-light">{stats.name}</h3>
                  )}
                  <div className="py-2 d-flex justify-content-around align-items-center mx-auto mx-md-0 ">
                    {stats &&
                      stats.tags &&
                      stats.tags.map((x, index) => {
                        return (
                          <span
                            key={index}
                            className="bg-brandtext text-dark px-2 py-1  fw-bold shadow fs-6 rounded-3 me-2"
                          >
                            {x}
                          </span>
                        );
                      })}
                  </div>
                  <div className="d-flex justify-content-around align-items-center mx-auto mx-md-0">
                    {stats && stats.socials.twitter && (
                      <a
                        className="d-flex nav-link my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.twitter}
                      >
                        <FaTwitter size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.instagram && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.instagram}
                      >
                        <FaInstagram size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.youtube && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.youtube}
                      >
                        <FaYoutube size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.twitch && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.twitch}
                      >
                        <FaTwitch size={16} className="" />
                      </a>
                    )}
                    {stats && stats.socials.website && (
                      <a
                        className="d-flex nav-link  my-auto member-social rounded-circle p-3 mx-2"
                        target="_blank"
                        rel="noreferrer"
                        href={stats.socials.website}
                      >
                        <FaGlobe size={16} className="" />
                      </a>
                    )}{" "}
                  </div>
                </div>
              </Row>
              <Row className="py-3 px-1 px-md-5">
                <Col className="d-flex flex-column flex-md-row justify-content-center align-items-center">
                  <div className="text-center">
                    {stats && stats.ign && <h3>{stats.ign}'s Bio</h3>}
                    {stats &&
                      stats.bio &&
                      stats.bio.map((x, index) => {
                        return (
                          <div key={index} className="mb-5">
                            <p className="text-break text-brand fs-5 fw-normal">
                              {x.question}
                            </p>
                            <p
                              className="text-break text-white fs-5 fw-light"
                              dangerouslySetInnerHTML={{ __html: x.answer }}
                            ></p>
                          </div>
                        );
                      })}
                  </div>
                </Col>
              </Row>
            </Container>

            {stats && stats.socials.youtube && (
              <Container className="pb-5" style={{ background: "#1E2229" }}>
                <h2 className="p-3">Recent videos On Youtube</h2>
                <Container className="d-flex justify-content-center align-items-center">
                  <Row className="d-flex flex-column flex-md-row justify-content-around ">
                    {recentVideos &&
                      recentVideos &&
                      recentVideos.map((x, index) => {
                        return (
                          <Col md={3} className="mb-3">
                            {x && x.snippet && (
                              <div className="h-100 d-flex flex-column flex-wrap justify-content-between px-0 ytsec">
                                <a
                                  href={`https://www.youtube.com/watch?v=${recentVideosIds[index]}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-center"
                                >
                                  <img
                                    src={x.snippet.thumbnails.medium.url}
                                    className="img-fluid"
                                    alt="thumbnail for yt video"
                                  />
                                </a>
                                <h4 className="p-3  "> {x.snippet.title}</h4>
                                <h5 className="p-3 display-6 fs-6 fw-light ">
                                  {" "}
                                  {viewCounts(x.statistics.viewCount)} Views
                                </h5>
                              </div>
                            )}
                          </Col>
                        );
                      })}
                  </Row>
                </Container>
              </Container>
            )}
            {stats && stats.twitch && (
              <Container className="pb-5" style={{ background: "#1E2229" }}>
                <h2 className="p-3">{stats.ign} on Twitch</h2>
                <Container className="mx-auto text-center twitch-container">
                  <iframe
                    title="twitch tv"
                    src={`https://player.twitch.tv/?channel=${stats.twitch}&parent=${org}&muted=true`}
                    allowFullScreen
                  ></iframe>
                </Container>
              </Container>
            )}
            {stats && stats.twitter && (
              <Container
                className="mx-auto text-center "
                style={{ maxWidth: "700px" }}
              >
                <TwitterFollowButton screenName={stats.twitter} />
                <TwitterTimelineEmbed
                  transparent
                  noFooter
                  theme="dark"
                  sourceType="profile"
                  placeholder="loading Tweets"
                  screenName={stats.twitter}
                  options={{ height: 200, tweetLimit: 3 }}
                />
              </Container>
            )}
          </div>
        </>
      }
    </>
  );
}
